<template>
  <div id="app">
    <Main v-if="logged"></Main>
    <router-view v-else />
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from "vuex";
import ls from "local-storage";
import Main from "@/views/layout/Main"
export default {
  name: "App",
  metaInfo () {
    return {
      title: this.title,
      titleTemplate: 'Hệ thống báo giá | %s'
    }
  },
  components: {
    Main
  },
  computed: {
    ...mapGetters("account", ["logged"]),
    ...mapGetters(["path", "full_path"]),
  },
  data() {
    return {
      showText: false,
    };
  },
  mounted() {
    this.checkLoged();
  },
  methods: {
    ...mapActions("account", ["getAccountInfo"]),
    checkLoged() {
      let authen = ls.get("authen");
      if (!authen) {
        if (this.path !== "register") {
          this.$router.push({ name: "account-login" });
        }
      } else {
        if (!this.logged) {
          this.getAccountInfo();
        }
      }
    },

    toggleMenuParent(value) {
      this.showText = value;
    },
  },
};
</script>

<style>
.app-menu-left {
  min-height: 100vh;
  width: 50px;
  background-color: #1975b8;
  transition: 0.3s;
}
.app-content-right {
  /*width: calc(100% - 50px);*/
  /*height: 100%;*/
  height: 100vh;
   width: 100%;
  display: flex;
  flex-direction: column;
  transition: 0.3s;
  background: #effafe;
}
.app-content-right .header-top {
  background-color: #fff;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px #DFE8FD;

}
.app-content-right .content-bottom {
  height: 100%;
  margin: 20px 10px;
  background: #ffffff;
  border-radius: 13px;
  padding: 20px 10px;
}


/*Hiệu ứng*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
